<template>
  <div v-if="isAdminMode" class="admin-banner row items-center justify-center q-py-xs q-px-md">
    <q-icon name="fas fa-user-shield" class="q-mr-sm" />
    <div class="text-caption text-weight-medium">
      Retailer <strong>{{ retailerLabel }}</strong> admin session as <strong>{{ adminLabel }}</strong>
    </div>
    <q-space />
    <q-btn flat dense size="sm" label="End Admin Session" class="q-ml-md" @click="onEndSession" />
  </div>
</template>

<script setup>
const router = useRouter()
const adminStore = useAdminStore()
const { session, isAdminMode, checked } = storeToRefs(adminStore)

const retailerLabel = computed(() => session.value?.retailer?.displayName || session.value?.retailer?.domain || 'retailer')
const adminLabel = computed(() => session.value?.admin?.email || 'admin')

onMounted(() => {
  if (!checked.value && adminStore.hasAdminMarker()) {
    adminStore.fetchSession()
  }
})

async function onEndSession() {
  await adminStore.logout()
  router.push({ name: 'AdminExpired', query: { reason: 'logout' } })
}
</script>

<style lang="scss" scoped>
// PEG-509 AC5: visually distinct cautionary indicator (orange) — clearly communicates
// the admin is impersonating a retailer view without alarming.
.admin-banner {
  background: $warning; // amber-700
  min-height: 32px;
}
</style>
